import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class RepairsService {

    constructor(private http : HttpClient) { }

    private BASE_URL = environment.apiURL;
    private OPTIONS = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json; charset=UTF-8'
        })
    }

    listInProgressRepair(){
        let url = this.BASE_URL + "repairs/list/progress"
        return this.http.get(url, this.OPTIONS)
    }

    listHistoryRepair(startDate : any, endDate : any){
      let url = this.BASE_URL + "repairs/list/historic?startDate=" + startDate + "&endDate=" + endDate
      return this.http.get(url, this.OPTIONS)
    }

    fileUpdateInTMPFolder(file : any){
      let url = this.BASE_URL + "files/uploadFile"
      const OPTIONS = {
        headers : new HttpHeaders({})
      }
      var formData = new FormData()
      formData.append('file', file, file.name)
      formData.append('type', 'IMAGE')
      return this.http.post(url, formData, OPTIONS)
    }

    postNewRepair(body : any){
      let url = this.BASE_URL + "repairs/create"
      return this.http.post(url, body, this.OPTIONS)
    }

    checkDeviceForSerialNumber(serialNumber : any){
      let url = this.BASE_URL + "repairs/checkSerialNumber?serialNumber=" + serialNumber
      return this.http.get(url, this.OPTIONS)
    }

    listRmaHistoryFromDevice(uuidDevice : any){
      let url = this.BASE_URL + "repairs/list/rmaHistoric?uuidDevice=" + uuidDevice
      return this.http.get(url, this.OPTIONS)
    }

    getRepairDetails(uuid : any){
      let url = this.BASE_URL + "repairs/details?repairUuid=" + uuid
      return this.http.get(url, this.OPTIONS)
    }

    getCentersFormElements(){
      let url = this.BASE_URL + "repairs/formElements/centers"
      return this.http.get(url, this.OPTIONS)
    }

    getAddressBookFormElements(centerUuid : any){
      let url = this.BASE_URL + "repairs/formElements/addressBook?centerUuid=" + centerUuid
      return this.http.get(url, this.OPTIONS)
    }

    getModelsFormElements(manufacturerUuid : any){
      let url = this.BASE_URL + "repairs/formElements/models?manufacturerUuid=" + manufacturerUuid
      return this.http.get(url, this.OPTIONS)
    }

    getManufacturersFormElements(){
      let url = this.BASE_URL + "repairs/formElements/manufacturer"
      return this.http.get(url, this.OPTIONS)
    }

    postCommentInRepairDetails(body : any){
      let url = this.BASE_URL + "repairs/comment"
      return this.http.post(url, body, this.OPTIONS)
    }

    getSpareParts(uuid: string) {
      let url = this.BASE_URL + "repairs/sparePart/list?uuid=" + uuid;
      return this.http.get(url, this.OPTIONS);
    }
}
